import { id } from "date-fns/locale";
import React, { Component } from "react";

class CountryDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      selected: null,
      searchTerm: "",
    };
    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    // Set initial value from props
    if (this.props.value) {
      this.setState({ selected: this.props.value });
    }
  }

  componentDidUpdate(prevProps) {
    // Update selected when value prop changes
    if (this.props.value !== prevProps.value && this.props.value !== this.state.selected) {
      this.setState({ selected: this.props.value });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  };

  toggleDropdown = () => {
    this.setState((prev) => ({
      isOpen: !prev.isOpen,
      searchTerm: "", // reset search when opened
    }));
  };

  handleSearchChange = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  handleSelect = (option) => {
    this.setState({
      selected: option,
      isOpen: false,
    });
    this.props.onChange?.(option);
  };

  render() {
    const {
      label = "Select Option",
      name = "dropdown",
      options = [],
      placeholder = "Select...",
      searchPlaceholder = "Search...",
      required,
      showSearch = true,
      error,
      value
    } = this.props;

    const { isOpen, selected, searchTerm } = this.state;

    const filteredOptions = options.filter((option) =>
      option.toLowerCase().includes(searchTerm.toLowerCase())
    );
    return (
      <div className={`${this.props.styles.custom_dropdown} `} ref={this.wrapperRef}>
        <label htmlFor={name}>
          {label}
          {required && <span className={this.props.styles.required}>*</span>}
        </label>

        <div
          className={`${this.props.styles.dropdown_select} ${error ? this.props.styles.select_error_border : ""
            }`}
          onClick={this.toggleDropdown}
        >
          <span className={`${selected ? "" : this.props.styles.slected} ${this.props.styles.dropdown_label}`}>
            {selected ? selected : placeholder}
          </span>
          <span className={this.props.styles.arrow_icon}>
            <img src="/images/downarrow_golden.svg" alt="arrow" />
          </span>
        </div>

        {isOpen && (
          <div className={this.props.styles.dropdown_open}>
            {showSearch && (
              <input
                type="text"
                placeholder={searchPlaceholder}
                value={searchTerm}
                onChange={this.handleSearchChange}
                style={{
                  width: "100%",
                  padding: "8px 10px",
                  border: "none",
                  borderBottom: "1px solid #eee",
                  outline: "none",
                  boxSizing: "border-box",
                  position: "sticky",
                  top: 0,
                }}
              />
            )}

            {filteredOptions.length > 0 ? (
              <ul className={this.props.styles.dropdown_list}>
                {filteredOptions.map((option) => (
                  <li
                    key={option}
                    onClick={() => this.handleSelect(option)}
                    className={this.props.styles.dropdown_option}
                  >
                    {option}
                  </li>
                ))}
              </ul>
            ) : (
              <div style={{ padding: "10px", fontSize: "14px", color: "#888" }}>
                No options found
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default CountryDropdown;
